import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { theme } from "../../theme.js";

export default function Helper({ title, cta, to }) {

    const navigate = useNavigate();
    const [isHovered, setIsHovered] = useState(false);
    
    const handleHelperClick = () => {
        navigate(to);
        console.log("Navigating to", to);
    };

    return (
        <p style={styles(theme).helper}>
          {title}{" "}
          <span 
            style={{...styles(theme).link, ...(isHovered && styles(theme).linkHover)}} 
            onClick={handleHelperClick}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            {cta}
          </span>
        </p>
    );
}

const styles = (theme) => ({
helper: {
    marginTop: theme.spacing.sm,
    color: theme.colors.textInverted,
    fontSize: theme.fonts.size.xs,
    textAlign: "center",
  },
link: {
    color: theme.colors.textInverted,
    fontWeight: theme.fonts.weight.semibold,
    cursor: "pointer",
    transition: theme.transitions.fast,
  },
  linkHover: {
    color: theme.colors.primary,    
    textDecoration: "underline",
  },
});